import { render, staticRenderFns } from "./user-market.vue?vue&type=template&id=5f73726f&scoped=true"
import script from "./user-market.vue?vue&type=script&lang=js"
export * from "./user-market.vue?vue&type=script&lang=js"
import style0 from "./user-market.vue?vue&type=style&index=0&id=5f73726f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f73726f",
  null
  
)

export default component.exports